module.exports = __webpack_public_path__ + "h5/img/praise02.73878bfe.png";